
@if (showLoader$ | async) {
  <div class="loader-container">
    <mat-spinner class="loader"></mat-spinner>
  </div>
}
